import { takeLatest, call, put } from "redux-saga/effects";
import {
  PARTNER_LOGO_LOAD,
  partnerLogoLoaded,
  partnerLogoLoadError,
} from "../../actions/partners";
import getLogo from "sc/backend/oncall/administration/partners/get-logo";

const partnersPageLoadSaga = function*(action) {
  try {
    const result = yield call(getLogo, action.payload.logoName);
    yield put(partnerLogoLoaded(result.logo));
  } catch (ignore) {
    yield put(partnerLogoLoadError());
  }
};

export default function*() {
  //noinspection JSCheckFunctionSignatures
  yield takeLatest(PARTNER_LOGO_LOAD, partnersPageLoadSaga);
}



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/sagas/partners/logo-load.js